<template>
  <div>
    <p class="subtitle">Theme</p>

    <div class="room-title" v-if="updatingTheme">Updating theme...</div>
    <div v-else>
      <div class="settings_line">
        <h5 class="room-title">Room Background</h5>
        <div
            style="
          display: flex;
          gap: 16px;
          padding-top: 16px;
          padding-left: 0 !important;
        "
        >
          <button
              @click="setRoomBackground(color)"
              v-for="color in colors"
              :key="color"
          >
          <span
              :style="{
              ...(roomTheme &&
                roomTheme.roomBackgroundColor === color && {
                  border: '1px solid rgba(0,0,0, 1)',
                }),
              width: '24px',
              display: 'block',
              height: '24px',
              borderRadius: '8px',
              background: color,
            }"
          ></span>
          </button>
        </div>
        <!-- <dropDownWithColor
          :default_item="'Default color'"
          :options="colorChoices"
          @setItem="setBgColor"
        ></dropDownWithColor> -->
      </div>

      <div class="settings_line" v-if="!useSameColor">
        <h5 class="room-title">Waiting Room Background</h5>
        <div style="display: flex; gap: 16px; padding-top: 16px">
          <button
              @click="setWaitingRoomBackground(color)"
              v-for="color in colors"
              :key="color"
          >
          <span
              :style="{
              ...(roomTheme &&
                roomTheme.waitingRoomBackgroundColor === color && {
                  border: '1px solid rgba(0,0,0, 1)',
                }),
              width: '24px',
              display: 'block',
              height: '24px',
              borderRadius: '8px',
              background: color,
            }"
          ></span>
          </button>
        </div>
        <!-- <dropDownWithColor
          :default_item="'Default color'"
          :waitingRoom="true"
          :options="colorChoices"
          @setItem="setWaitingColor"
        ></dropDownWithColor> -->
      </div>

      <div class="checkbox_wrap">
        <input
            type="checkbox"
            name="ch1"
            id="ch1"
            :checked="useSameColor"
            @change="setSameRoomColors"
        />
        <label for="ch1">
          <span></span>
          Use same as Room Background
        </label>
      </div>

      <label for="logo" class="colored_btn hover_op">{{
          roomTheme.logoURL ? "Replace Logo" : "Add Logo"
        }}</label>
      <input
          accept=".png,.svg,.jpg,.jpeg"
          v-on:change="uploadImage($event.target.files[0])"
          type="file"
          id="logo"
      />

      <div class="logo_line df s_betwen" v-if="roomTheme.logoURL != null">
        <img v-bind:src="roomTheme.logoURL" alt="" height="72px" />

        <button class="hover_op df remove_btn" @click="removeNewLogo">
          Remove
          <img src="@/assets/img/remove_icon.svg" alt="" />
        </button>
      </div>

      <label for="background" class="colored_btn hover_op">{{
          uploadedBackground ? "Replace background" : "Add background"
        }}</label>
      <input
          accept=".png,.svg,.jpg,.jpeg"
          v-on:change="uploadBackground($event.target.files[0])"
          type="file"
          id="background"
      />

      <div class="logo_line df s_betwen" v-if="uploadedBackground != null">
        <img v-bind:src="backgroundPreview" alt="" height="72px" />

        <button class="hover_op df remove_btn" @click="removeNewBackground">
          Remove
          <img src="@/assets/img/remove_icon.svg" alt="" />
        </button>
      </div>

      <div
          class="payed_restriction_overflow"
          v-if="!payedSubscription"
          @click="$store.commit('showModal', 'unlock_features')"
      ></div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import dropDownWithColor from "@/components/dropDownWithColor.vue";

export default {
  name: "RoomBrandingSettings",

  data() {
    return {
      uploadPreview: null,
      uploadedImage: null,
      backgroundPreview: null,
      uploadedBackground: null,
      useSameColor: "true",
      selectedRoomBackground: "",
      selectedWaitingRoomBackground: "",
      colorChoices: [
        {
          label: "#f9f4ef",
          id: "#f9f4ef",
        },
        {
          label: "#f2edd7",
          id: "#f2edd7",
        },
        {
          label: "#b5eaea",
          id: "#b5eaea",
        },
        {
          label: "#b8dfd8",
          id: "#b8dfd8",
        },
      ],
      colors: ["#fff", "#f9f4ef", "#b5eaea", "#b8dfd8"],
    };
  },

  watch: {
    roomBackground: {
      immediate: true,
      handler(color) {
        this.selectedRoomBackground = color;
      },
    },

    waitingRoomBackground: {
      immediate: true,
      handler(color) {
        this.selectedWaitingRoomBackground = color;
      },
    },
  },

  components: {
    dropDownWithColor,
  },

  methods: {
    setSameRoomColors(e) {
      if (!this.$store.state.meeting.meetingPermissions.canChangeRoomColors) {
        e.target.checked = true;
      }

      this.$store.dispatch("setSameRoomColors");
    },

    async removeNewLogo() {
      await this.$store.dispatch("setLogo", { delete: true });
    },

    async uploadImage(file) {
      await this.$store.dispatch("setLogo", file);
    },

    uploadBackground(file) {
      this.uploadedBackground = file;
      const reader = new FileReader();
      reader.addEventListener("load", () => {
        this.backgroundPreview = reader.result;
      });
      reader.readAsDataURL(file);
    },

    setBgColor(setItem) {
      this.useSameColor = false;
      this.selectedRoomBackground = setItem;
      this.setRoomBackground(setItem);
    },

    setWaitingColor(setItem) {
      this.useSameColor = false;
      this.selectedWaitingRoomBackground = setItem;
      this.setWaitingRoomBackground(setItem);
    },

    setRoomBackground(color) {
      this.$store.dispatch("setRoomBackgroundColor", color);
    },

    setWaitingRoomBackground(color) {
      this.$store.dispatch("setRoomWaitingBackgroundColor", color);
    },
  },

  computed: {
    updatingTheme(){
      return this.$store.state.meeting.updatingTheme
    },
    roomTheme() {
      return this.$store.getters.roomTheme;
    },

    roomLogo() {
      return this.$store.state.meeting.roomData.logo;
    },

    roomId() {
      return this.$store.state.meeting.roomData._id;
    },

    meetingId() {
      return this.$store.state.meeting.roomData.dailyRoomName;
    },

    waitingRoomBackground() {
      console.log("test1", this.$store.getters.roomTheme.waitingRoomBackground);
      return this.$store.getters.roomTheme.waitingRoomBackground;
    },

    roomBackground() {
      return this.$store.getters.roomTheme.roomBackground;
    },

    payedSubscription() {
      if (this.$store.state.billing.subscription == null) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.room-title {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  letter-spacing: 0px;
  text-align: left;
  line-height: 24px;
}

.subtitle {
  margin-top: 32px !important;
}

.payed_restriction_overflow {
  z-index: 10;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  cursor: pointer;
}

label {
  cursor: pointer;
}

#logo {
  display: none;
}

#background {
  display: none;
}
</style>
